import { SpreadsheetColumnSettingsDef } from "@components/spreadsheet/SpreadsheetColumnSettings";

export const ELIMINATING_ENTRY_COLUMNS_STORAGE_KEY =
    "eliminating-entry-spreadsheet-hidden-columns";
export const DEFAULT_HIDDEN_ELIMINATING_ENTRY_FIELDS = ["excludeFrom1099"];

type EliminatingEntryColumnField =
    | ""
    | "entityId"
    | "accountId"
    | "counterpartyId"
    | "classIds"
    | "debitAmount"
    | "creditAmount"
    | "excludeFrom1099"
    | "description";

export interface EliminatingEntryColumnMeta extends Omit<
    SpreadsheetColumnSettingsDef,
    "field"
> {
    field: EliminatingEntryColumnField;
    gridWidth: string;
}

export const ELIMINATING_ENTRY_COLUMNS: readonly EliminatingEntryColumnMeta[] =
    [
        { field: "", label: "", immutable: true, gridWidth: "40px" },
        {
            field: "entityId",
            label: "Entity",
            immutable: true,
            gridWidth: "220fr",
        },
        {
            field: "accountId",
            label: "Account",
            immutable: true,
            gridWidth: "360fr",
        },
        {
            field: "counterpartyId",
            label: "Counterparty",
            gridWidth: "150fr",
        },
        { field: "classIds", label: "Class", gridWidth: "60fr" },
        {
            field: "debitAmount",
            label: "Debit",
            immutable: true,
            gridWidth: "122fr",
        },
        {
            field: "creditAmount",
            label: "Credit",
            immutable: true,
            gridWidth: "122fr",
        },
        {
            field: "excludeFrom1099",
            label: "Exclude from 1099",
            gridWidth: "130fr",
        },
        {
            field: "description",
            label: "Description",
            gridWidth: "300fr",
        },
    ];

interface VisibleColumnsParams {
    hiddenFields: ReadonlySet<string>;
    isClassesActivated: boolean;
}

export function getVisibleEliminatingEntryColumns({
    hiddenFields,
    isClassesActivated,
}: VisibleColumnsParams): readonly EliminatingEntryColumnMeta[] {
    return ELIMINATING_ENTRY_COLUMNS.filter(
        (column) =>
            (column.field !== "classIds" || isClassesActivated) &&
            (column.immutable || !hiddenFields.has(column.field)),
    );
}

export function getEliminatingEntryColumnSettings(
    isClassesActivated: boolean,
): readonly EliminatingEntryColumnMeta[] {
    return ELIMINATING_ENTRY_COLUMNS.filter(
        (column) =>
            column.label !== "" &&
            (column.field !== "classIds" || isClassesActivated),
    );
}

export function buildEliminatingGridTemplateColumns(
    columns: readonly EliminatingEntryColumnMeta[],
): string {
    return columns.map(({ gridWidth }) => gridWidth).join(" ");
}
